// extracted by mini-css-extract-plugin
module.exports = {"calculatorTable":"index-module__calculatorTable___9OWSt","tableHeadContainer":"index-module__tableHeadContainer___1u9OI","cellText":"index-module__cellText___E6EHF"};